/**
 * Formats factor names for display.
 * Converts underscore-separated stat combos to readable format:
 *   "pts_reb" → "pts + reb"
 *   "pts_reb_ast" → "pts + reb + ast"
 * Leaves other names unchanged.
 */
export function formatFactorName(factor: string): string {
  if (/^[a-z0-9]+(_[a-z0-9]+)+$/.test(factor)) {
    return factor.replace(/_/g, ' + ');
  }
  return factor;
}
